module.exports = __webpack_public_path__ + "app/principal/companies-list-1QH36wuR.html";